import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/skeletons/GeneralSkeleton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VipPageContent"] */ "/app/src/modules/vip/VipPageContent/index.tsx");
